import { LabradorComponent } from '@/types/component';
import { LabradorDirektTeaser } from 'base/components/labrador/DirektTeaser';

export const SvenskdamLabradorDirektTeaser: LabradorComponent = ({ type, data, meta, descendants }) => {
  return <LabradorDirektTeaser {...{ type, meta, descendants }} data={{ ...data, headline: 'SVENSK DAM DIREKT' }} />;
};
